// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._eYUOP{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;flex-direction:column}._eYUOP .jxL8eK{position:relative;flex-grow:2}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainUiBlock": "_eYUOP",
	"tooltipContainerWrapper": "jxL8eK"
};
export default ___CSS_LOADER_EXPORT___;
